/**
 * useDocumentLineage (CHAP-491) — the Version History surface.
 *
 * `documentId` is resolved server-side from each version's R2 key against the
 * data room, so it is null when the source file has never been uploaded. The
 * page renders those versions as plain text rather than a download link.
 */
import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../lib/api.js';

export interface LineageVersion {
  label: string;
  date: string;
  status: 'current' | 'superseded';
  delta: string;
  /** Financial-family only; null on families that do not track them. */
  suites: string | null;
  cost: string | null;
  /** Null when the source file is not in the data room. */
  documentId: string | null;
}

export interface LineageFamily {
  id: string;
  family: string;
  blurb: string;
  /** What the series as a whole reveals — the narrative a flat list hides. */
  reveals: string;
  versions: LineageVersion[];
}

export function useDocumentLineage(slug: string) {
  return useQuery<{ families: LineageFamily[] }, Error>({
    queryKey: ['document-lineage', slug],
    queryFn: () => apiGet(`/api/c/${slug}/document-lineage`),
    enabled: !!slug,
  });
}
